export default {
    id: 'ID',
    provider: 'Provider',
    client_id: 'Client ID',
    client_secret: 'Client Secret',
    redirect: 'URL',
    created_at: 'Created at'
}
